import moment from "moment";
import { getUITranslation } from "../utils/get_ui_translation";
import * as Dialog from "../framework/dialog";
import * as Popup from "../framework/components/popup";
import { showLifecycle, wireTrigger } from "./invoice_lifecycle";
import vex from "../framework/vex_dialog";

/* global _money */

const INVOICE_NUMBER_PADDING = 3;

let advanceTotal = 0;

$(function () {
  $(document)
    .on("submit", ".js-create-invoice-advance", onCreateAdvance)
    .on("keyup change", "#advance-percent-field", _.debounce(onAdvancePercent, 100))
    .on("keyup change", "#advance-amount-field", _.debounce(onAdvanceAmount, 100))
    .on("click", ".js-set-invoice-number", onSetNumber)
    .on("click", ".js-dismiss-invoice-incorrect-numbering", onDismissInvoiceIncorrectNumbering);

  document.querySelectorAll(".js-invoice-lifecycle-trigger").forEach((el) => wireTrigger(el, () => onShowLifecycle(el)));
});

// The popup body is fetched per invoice: locked invoices have no reachable edit page, so the
// timeline is rendered server-side on demand and shown here. The popup opens on the spot over
// the placeholder showLifecycle injects synchronously.
function onShowLifecycle(el) {
  const popupEl = document.querySelector("#invoice-lifecycle-popup");
  const slotEl = popupEl?.querySelector(".js-invoice-lifecycle-popup-slot");
  if (!slotEl) return;

  showLifecycle(slotEl, {
    url: el.dataset.url,
    name: el.dataset.invoiceNumber,
    onError: () => Popup.close(popupEl),
  });
  Popup.open(popupEl);
}

function onCreateAdvance(e) {
  e.preventDefault();
  let $form = $(this);
  advanceTotal = parseFloat($form.data("total"));
  const amount = Math.round(advanceTotal * 0.3 * 100) / 100;

  const dialogTitle = getUITranslation("Montant de l'acompte");
  const dialogHtml = `
    <label class="has-block has-mb-03">
      <span class="label label--sm"> ${getUITranslation("Pourcentage du total")} </span>
      <div class="text-input text-input--md">
        <input class="text-input__input has-min-w-fit" type="number" step="0.001" value="30" id="advance-percent-field" />
        <span class="text-input__suffix">%</span>
      </div>
    </label>
    <label class="has-block has-mb-03">
      <span class="label label--sm"> ${getUITranslation("Montant en")} ${_money.name}</span>
      <div class="text-input text-input--md">
        <input class="text-input__input has-min-w-fit" type="number" step="0.001" value="${amount}" id="advance-amount-field" />
        <span class="text-input__suffix">${_money.symbol}</span>
      </div>
    </label>`;
  const createButton = _.extend(vex.dialog.buttons.YES, {
    text: getUITranslation("Créer l'acompte"),
    type: "button",
    className: "vex-dialog-button-primary",
    click: function () {
      window._closeHTMLDialog($("#advance-amount-field").val());
    },
  });

  Dialog.html(dialogTitle, dialogHtml, [Dialog.CANCEL, createButton], function (result) {
    const parsedResult = parseFloat(result);

    if (isFinite(parsedResult) && parsedResult !== 0) {
      $form.find("[name=amount]").val(parsedResult);
      $form.get(0).submit();
    }
  });
}

function onAdvanceAmount() {
  const amount = parseFloat($(this).val());
  const percent = Math.round((amount / advanceTotal) * 100 * 1000) / 1000;
  if (isFinite(percent)) {
    $("#advance-percent-field").val(percent);
  }
}

function onAdvancePercent() {
  const percent = parseFloat($(this).val());
  const amount = Math.round(((percent * advanceTotal) / 100) * 100) / 100;

  if (isFinite(amount)) {
    $("#advance-amount-field").val(amount);
  }
}

function onSetNumber() {
  let id = $(this).data("id");
  ajax({
    url: p`/ajax/invoices/${id}/number_proposal`,
    method: "GET",
    error: function () {
      Dialog.alert(getUITranslation("Erreur"), getUITranslation("Action impossible"), "error");
    },
    success: function (data) {
      if (data.success) {
        // PROPOSE THE NUMBER WITH A DIALOG
        let resetMessage;
        if (data.reset_date_mandatory) {
          resetMessage = `
            <div class='alert alert--alert has-mt-03'>
              <div class="state-indicator state-indicator--alert state-indicator--md">
                <svg role="img" fill="currentColor" aria-hidden="" class="icon icon--sm state-indicator__icon">
                  <use href="/icons/sprite.svg#info--circle--filled"></use>
                </svg>
              </div>
              ${getUITranslation(
                "La date de cette facture est antérieure à la dernière facture numérotée. Si vous numérotez, la date sera automatiquement repositionnée aujourd'hui."
              )}
            </div>
            <input type="hidden" id="set-number-date" value="on"></input>
          `;
        } else {
          resetMessage = `
            <label class="checkable-container has-mt-03">
              <input type="checkbox" id="set-number-date" checked class="checkbox"/>
              <p> ${getUITranslation("Dater la facture d'aujourd'hui")} </p>
            </label>
            `;
        }
        let html = `
          <label class="form-label">Préfixe</label>
          <input type="text" value="${data.prefix || ""}" id="set-number-prefix" class="form-control" />
          <label class="form-label">Numéro</label>
          <input type="number" value="${data.number}" id="set-number-number" class="form-control" />
          ${resetMessage}
        `;
        let okButton = _.extend(vex.dialog.buttons.YES, {
          text: "Ok",
          type: "button",
          className: "vex-dialog-button-primary",
          click: function () {
            window._closeHTMLDialog({
              prefix: $("#set-number-prefix").val(),
              number: $("#set-number-number").val(),
              date: $("#set-number-date").val(),
            });
          },
        });
        Dialog.html(getUITranslation("Prochain numéro"), html, [Dialog.CANCEL, okButton], function (result) {
          setNumber(id, result.prefix, result.number, result.date == "on", data.reset_date_mandatory);
        });
      } else {
        // WARNING, THERE IS A CONFLICTING INVOICE NUMBER TO BE SOLVED FIRST
        let url = p`/invoices/${data.conflicting_invoice_id}/edit`;
        let name = [getUITranslation("Facture"), data.conflicting_invoice_name].join(" ");

        let message = [
          getUITranslation(`Une autre facture déjà numérotée a une date postérieure à celle ci.`),
          `<a href="${url}" target="_blank">${name}</a>`,
          getUITranslation(`Il vous faut résoudre ce conflit de factures manuellement.`),
        ].join(`<br/>`);

        Dialog.alert(getUITranslation("Action impossible"), message, "error");
      }
    },
  });
}

function setNumber(id, prefix, number, resetDate, reloadAfter) {
  let date = undefined;
  if (resetDate) {
    date = moment().format("YYYY-MM-DD");
  }
  ajax({
    url: p`/ajax/invoices/${id}/update`,
    method: "POST",
    data: {
      "invoice[number_str]": _.padStart(number, INVOICE_NUMBER_PADDING, "0"),
      "invoice[prefix]": prefix,
      "invoice[date]": date,
    },
    error: function () {
      Dialog.alert(getUITranslation("Erreur"), getUITranslation("Action impossible"), "error");
    },
    success: function (data) {
      if (data.success) {
        const invoiceElement = document.getElementById(`invoice-${id}`);
        invoiceElement.querySelector(".js-invoice-name").innerText = data.invoice_name;
        invoiceElement.querySelector(".js-set-invoice-number").remove();
        if (reloadAfter) {
          location.reload();
        }
      } else {
        const errors = data?.errors || [];
        let message = [getUITranslation(`Action impossible`), ...errors].join(`<br/>`);
        Dialog.alert(getUITranslation("Erreur"), message, "error");
      }
    },
  });
}

function onDismissInvoiceIncorrectNumbering() {
  const invoice_id = this.getAttribute("data-invoice-id");
  ajax({
    method: "post",
    url: p`/ajax/invoices/${invoice_id}/update`,
    data: {
      invoice: {
        dismiss_incorrectly_numbered: true,
      },
    },
    success: function () {
      location.reload();
    },
  });
}
